import { render, staticRenderFns } from "./aChmRowRate.vue?vue&type=template&id=4f80d816&scoped=true"
import script from "./aChmRowRate.vue?vue&type=script&lang=js"
export * from "./aChmRowRate.vue?vue&type=script&lang=js"
import style0 from "./aChmRowRate.vue?vue&type=style&index=0&id=4f80d816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f80d816",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip,VWindow,VWindowItem})
